export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { title: "Dashboard", requiresAuth: true },
    component: () => import("../../views/main/dashboard.vue"),
  },

    {
    path: "/notifications",
    name: "Notifications",
    meta: { title: "Notification List", requiresAuth: true },
    component: () => import("../../views/main/menu/notif.vue"),
  },
  {
    path: "/registration",
    name: "Registration",
    meta: { title: "Registration", requiresAuth: true },
    component: () => import("../../views/main/menu/registration.vue"),
  },
  {
    path: "/organization",
    name: "Organization",
    meta: { title: "Organization List", requiresAuth: true },
    component: () => import("../../views/main/menu/organization.vue"),
  },
  {
    path: "/message",
    name: "Message",
    meta: { title: "Message", requiresAuth: true },
    component: () => import("../../views/main/menu/message.vue"),
  },

  // Profile Routes =======================================================
  {
    path: "/activities",
    name: "activities",
    meta: { title: "User Activities", requiresAuth: true },
    component: () => import("../../views/main/profile/activity.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    meta: { title: "User Profile", requiresAuth: true },
    component: () => import("../../views/main/profile/details.vue"),
  },
  {
    path: "/setting",
    name: "setting",
    meta: { title: "User setting", requiresAuth: true },
    component: () => import("../../views/main/profile/setting.vue"),
  },

  // Certificate Routes ===================================================
  {
    path: "/certificate/resolutions",
    name: "CertificateResolution",
    meta: {
      title: "Certificate Resolution",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/certificate/resolution.vue"),
  },

  // Setting Routes =======================================================
  {
    path: "/settings/advocacies",
    name: "SettingAdvocacies",
    meta: {
      title: "Setting Advocacies",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/settings/advocacies.vue"),
  },
  {
    path: "/settings/email-smtp",
    name: "SettingEmailSmtp",
    meta: {
      title: "Setting Advocacies",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/settings/email-smtp.vue"),
  },
  {
    path: "/settings/system-logs",
    name: "SettingSystemLogs",
    meta: {
      title: "Setting System Logs",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/settings/system-logs.vue"),
  },
  {
    path: "/settings/announcements",
    name: "SettingAnnounce",
    meta: {
      title: "Setting Announcements",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/settings/announces.vue"),
  },

  // Requests Routes =======================================================
  {
    path: "/request/accounts",
    name: "RequestAccount",
    meta: {
      title: "Account Requests",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/requests/accounts.vue"),
  },

  // Accounts Routes =======================================================
  {
    path: "/accounts/yorp",
    name: "AccountYorp",
    meta: {
      title: "YORP Accounts",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/accounts/yorp.vue"),
  },
  {
    path: "/accounts/organization",
    name: "AccountOrg",
    meta: {
      title: "Organization Accounts",
      requiresAuth: true,
      roles: ["admin", "secretariat"],
    },
    component: () => import("../../views/main/accounts/org.vue"),
  },
];
